namespace Areas.Account.Team{
    "use strict";
   
    let currentTeamRow: any;
    let selectedContact: any;
    let selectedVendor: any;
    let selectedAccount: any;

    export function onNewTeamRow(e: any) {
        currentTeamRow = e.data;
        currentTeamRow.accountId = e.component.option("AccountId");
        currentTeamRow.projectCCNumber = e.component.option("ProjectCCNumber");
        currentTeamRow.accountName = e.component.option("AccountName");
        currentTeamRow.projectId = e.component.option("ProjectId");
        selectedVendor = '';
        selectedContact = '';
        selectedAccount = e.component.option("ProjectCCNumber");
    }

    export function onSelectionChanged(e: any) {
        var selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            selectedVendor = selectedRows[0].vendorName;
            selectedAccount = selectedRows[0].projectCCNumber;
            selectedContact = selectedRows[0].displayName;
        }
    }

    export function onEditingStart(e: any) {
        currentTeamRow = e.data;
        selectedAccount = e.data.projectCCNumber;
    }


    export function selectContact() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogContactClosing);
    }

    export function selectAccount() {
        const grid: any = $("#TeamGrid").dxDataGrid("instance");
        const parameters = { projectId: grid.option("ProjectId") };

        const projectLookupDialog =
            new Areas.Dialogs.Project.ProjectLookupDialog(dialogAccountClosing, parameters);
    }

    export function selectVendor() {
        const vendorDialog = new Areas.Dialogs.VendorDialog(dialogVendorClosing)
    }


    function dialogContactClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#TeamGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateContactGridRow(dataGrid, rowIndex, data);
    }

    function dialogAccountClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#TeamGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateAccountGridRow(dataGrid, rowIndex, data);
    }

    function dialogVendorClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#TeamGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateVendorGridRow(dataGrid, rowIndex, data);
    }

    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentTeamRow === undefined || currentTeamRow === null) {
            return rowIndex;
        } else if (currentTeamRow.accountTeamId) {
            rowIndex = dataGrid.getRowIndexByKey(currentTeamRow.accountTeamId);
        }

        return rowIndex;
    }


    function updateContactGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "contactId", data.contactId);
        dataGrid.cellValue(rowIndex, "displayName", data.displayName);
        dataGrid.cellValue(rowIndex, "company", data.company);
        dataGrid.cellValue(rowIndex, "primaryEMail", data.primaryEMail);
        dataGrid.cellValue(rowIndex, "workPhone", data.workPhone);

        currentTeamRow.contactId = data.contactId;
        currentTeamRow.displayName = data.displayName;
        currentTeamRow.company = data.company;
        currentTeamRow.primaryEmail = data.primaryEMail;
        currentTeamRow.workPhone = data.workPhone;

        selectedContact = data.displayName;


        dataGrid.repaintRows([rowIndex]);
    }

    function updateAccountGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "accountId", data.accountId);
        dataGrid.cellValue(rowIndex, "projectCCNumber", data.projectCCNumber);
        dataGrid.cellValue(rowIndex, "accountName", data.accountName);

        currentTeamRow.accountId = data.accountId;
        currentTeamRow.projectCCNumber = data.projectCCNumber;
        currentTeamRow.accountName = data.accountName;

        selectedAccount = data.projectCCNumber;

        dataGrid.repaintRows([rowIndex]);
    }

    function updateVendorGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "vendorId", data.vendorId);
        dataGrid.cellValue(rowIndex, "vendorName", data.vendorName);

        currentTeamRow.vendorId = data.vendorId;
        currentTeamRow.vendorName = data.vendorName;

        selectedVendor = data.vendorName;

        dataGrid.repaintRows([rowIndex]);
    }

    export function onRowInserted(e: any) {
        selectedVendor = '';
        selectedContact = '';
        selectedAccount = e.component.option("ProjectCCNumber");
        currentTeamRow = null;
    }


    export function editContactTemplate(cellElement, cellInfo) {

        let displayName = !selectedContact ? "Select..." : selectedContact;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${displayName}</div><div class="dx-lookup-arrow" id="contact-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectContact);
        cellElement.append(html);
    }

    export function editAccountTemplate(cellElement, cellInfo) {
        let projectCCNumber = !selectedAccount ? "Select..." : selectedAccount;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${projectCCNumber}</div><div class="dx-lookup-arrow" id="account-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectAccount);
        cellElement.append(html);
    }

    export function editVendorTemplate(cellElement, cellInfo) {
        let vendorName = !selectedVendor ? "Select..." : selectedVendor;
      
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${vendorName}</div><div class="dx-lookup-arrow" id="vendor-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectVendor);
        cellElement.append(html);
    }

    export function goToActions(sharePointLink: string, projectInfoId: number) {
        return (e: any) => {
            if (e.value == 1) {
                Areas.Account.Team.goToContact();
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 3) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    export function goToContact() {
        const grid= $("#TeamGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = 0;
            if (isNotEmpty(row[0].contactId)) {
                id = row[0].contactId;
            }
            else {
                return;
            }

            let linkInfo = "/Contact/Profile/View/" + id;
            location.href = linkInfo;
        }
    }

    function goToSharePoint(sharePointLink: string) {
        let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
        if (sharePointLink != "") {
            window.open(linkInfo);
        }
        else {
            window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
        }
    }

    function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }
}